import { useCallback, useState } from "react";

type LongreadCount = {
  active: string;
  idList: string[];
  count: number;
};

export const useLongreadCounts = () => {
  const [data, setData] = useState<LongreadCount>({
    active: '',
    idList: [],
    count: 0,
  });

  const setLongreadCounts = useCallback(
    (active: string, idList: string[], count: number) => {
      setData((prev) => {
        const sameActive = prev.active === active;
        const sameCount = prev.count === count;
        const sameList =
          prev.idList === idList ||
          (prev.idList.length === idList.length &&
            prev.idList.every((id, i) => id === idList[i]));

        if (sameActive && sameCount && sameList) {
          return prev;
        }

        return { active, idList, count };
      });
    },
    [],
  );

  return [setLongreadCounts, data] as const;
};import { useCallback, useState } from "react";

type LongreadCount = {
  active: string;
  idList: string[];
  count: number;
};

export const useLongreadCounts = () => {
  const [data, setData] = useState<LongreadCount>({
    active: '',
    idList: [],
    count: 0,
  });

  const setLongreadCounts = useCallback(
    (active: string, idList: string[], count: number) => {
      setData((prev) => {
        const sameActive = prev.active === active;
        const sameCount = prev.count === count;
        const sameList =
          prev.idList === idList ||
          (prev.idList.length === idList.length &&
            prev.idList.every((id, i) => id === idList[i]));

        if (sameActive && sameCount && sameList) {
          return prev;
        }

        return { active, idList, count };
      });
    },
    [],
  );

  return [setLongreadCounts, data] as const;
};